import React from "react"
import {LexicalEditor, REDO_COMMAND, UNDO_COMMAND} from "lexical"
import ControlButtonStandard from "../../../../buttons/control-button/control-button-standard"

type Props = {
    editor  : LexicalEditor
    canUndo : boolean
    canRedo : boolean
}

export default function HistoryToolbar(props: Props): JSX.Element {
    const onClickUndo = () => props.editor.dispatchCommand(UNDO_COMMAND, undefined)
    const onClickRedo = () => props.editor.dispatchCommand(REDO_COMMAND, undefined)

    return (
        <>
            <ControlButtonStandard  iconClass   = "editor-i5-undo fs-16"
                                    isDisabled  = {!props.canUndo}
                                    onClick     = {onClickUndo}/>

            <ControlButtonStandard  iconClass   = "editor-i5-redo fs-16"
                                    isDisabled  = {!props.canRedo}
                                    onClick     = {onClickRedo}/>
        </>
    )
}